import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loading } from '../common/Loading';
import Unauthorized from '../common/Unauthorized';

export function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, menusLoaded, isAuthorized } = useAuth();
  const location = useLocation();

  // 1. Auth initialisation in progress → show loader
  if (isLoading) {
    return <Loading />;
  }

  // 2. Not authenticated → redirect to login
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        state={{ from: location }}
        replace
      />
    );
  }

  // 3. Authenticated but menus haven't loaded yet → show loader
  //    (prevents Unauthorized flash while the menus API call is in-flight)
  if (!menusLoaded) {
    return <Loading />;
  }

  // 4. Routes accessible to all authenticated users regardless of menu permissions
  const PUBLIC_AUTH_ROUTES = ['/user-profile'];

  // 5. Menus loaded — now safe to check authorization
  if (!PUBLIC_AUTH_ROUTES.includes(location.pathname) && !isAuthorized(location.pathname)) {
    if (React.isValidElement(children)) {
      return React.cloneElement(children, {}, <Unauthorized />);
    }
    return <Unauthorized />;
  }

  return children;
}
